// Add a new service by appending one object here — no component/CSS changes needed.
const services = [
  {
    id: "machinery-moving",
    title: "Machinery Moving",
    image: "/images/ServicesImages/MachineMoving.jpg",
    bg: "/images/ServicesImages/MachineryMovingBG.png",
    intro:
      "At Alpha 1 Industrial Services, machinery moving is the cornerstone of our comprehensive range of industrial relocation services. With an expert team specializing in the precise handling of various machinery, we bring extensive experience in seamlessly moving, installing, and relocating both new and used equipment across manufacturing plants in the Lower Mainland.",
    list: [
      "CNC",
      "HVAC Units",
      "Hot Water Tanks",
      "Boilers",
      "Water Jet",
      "Laser",
      "Press Brake",
      "Shear",
      "Milling Machine",
      "Lathe",
      "Air Handling Units",
    ],
  },
  {
    id: "warehousing",
    title: "Warehousing",
    image: "/images/ServicesImages/Warehousing.png",
    bg: "/images/ServicesImages/WarehousingBG.png",
    intro:
      "Our forthcoming warehousing solutions will revolutionize your storage and logistics needs. With a focus on safety, efficiency, and convenience, our state-of-the-art facilities will provide secure and hassle-free storage options for your business. Stay tuned for more information on how we can streamline your inventory management and distribution processes.",
  },
  {
    id: "truck-crane-services",
    title: "Truck & Crane Services",
    image: "/images/ServicesImages/TruckServicesOG.jpg",
    bg: "/images/ServicesImages/TruckServicesBG.png",
    intro:
      "At Alpha 1 Industrial Services, our truck services stand as a cornerstone within our array of specialized industrial solutions. Backed by a skilled team proficient in the intricacies of truck handling, we offer a seamless experience in transporting and relocating a diverse range of goods and equipment. With a wealth of expertise, we pride ourselves on efficiently moving, delivering, and installing items, both new and used, across a spectrum of industries in the Lower Mainland.",
    list: [
      "Hiab Cranes",
      "Stiff Boom Cranes",
      "Knuckle Boom Cranes",
      "Mobile Cranes",
    ],
  },
  {
    id: "millwright-services",
    title: "Millwright Services",
    image: "/images/ServicesImages/MillwrightServices.jpg",
    bg: "/images/ServicesImages/MillwrightServicesBG.png",
    intro:
      "Alpha 1 Industrial Services takes pride in offering top-notch millwright services that form the bedrock of our comprehensive industrial solutions. With a dedicated team of experienced professionals specializing in precision machinery installation, maintenance, repair, electrical, and mechanical, all services are taken care of in house. Our expertise spans a wide range of industries, and we are committed to ensuring the smooth operation of your equipment, enhancing efficiency, and minimizing downtime — from new installations to optimizing existing setups in the Lower Mainland and beyond.",
  },
];

export default services;
